<template>
  <div class="coupon-page">
    <!-- 顶部广告区域 -->
    <!-- <div class="advertisement">
      <img :src="imgUrl" alt="优惠券广告" class="ad-img" />
    </div> -->

    <!-- 优惠券主体区域 -->
    <div class="coupon-container">
      <div class="coupon-header">
        <div class="title-section">
          <div class="icon-wrapper">
            <img :src="couponIcon" alt="优惠券图标" class="coupon-icon" />
          </div>
          <h1 class="title-text">领券中心</h1>
        </div>
        <div class="subtitle cursor-pointer" @click="toMyCoupon">我的优惠券>></div>
      </div>

      <!-- 优惠券列表 -->
      <div class="coupon-body" v-newloading="loading">
        <div class="coupon-grid">
          <coupon-item
            v-for="item in couponList"
            :key="item.id"
            :item="item"
            @hadPick="getCoupon"
            class="coupon-item"
          ></coupon-item>
        </div>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="custom-pagination"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import couponIcon from "@/assets/img/newProducts/coupon-icon.png";
import { getCustomerCouponCanPickList } from "@/api/coupon/index.js";
import CouponItem from "../../components/coupon/components/Coupon.vue";

export default {
  components: {
    CouponItem
  },
  data() {
    return {
      loading: true,
      couponIcon,
      couponList: [],
      total: 0,
      page: 1,
      size: 20
    };
  },
  methods: {
    toMyCoupon() {
      this.$router.push({
        path: "/new-products/system-center/my-wallet",
        query: { name: "coupon" }
      });
    },
    // 获取优惠券
    async getCoupon() {
      this.loading = true;
      try {
        let res = await getCustomerCouponCanPickList({ page: this.page, pageSize: this.size });
        this.couponList = res.rows;
        this.total = res.totalSize;
      } catch (error) {
        console.error("获取优惠券失败:", error);
        this.$message.error("获取优惠券失败，请稍后重试");
      }
      this.loading = false;
    },
    handleSizeChange(val) {
      this.size = val;
      this.getCoupon();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getCoupon();
    }
  },
  created() {
    this.getCoupon();
  }
};
</script>

<style lang="scss" scoped>
.coupon-page {
  width: 100%;
  margin: 0 auto;
  // padding: 0 16px 24px;
  // background-color: #f8f9fa;

  .advertisement {
    margin: 16px 0 24px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

    .ad-img {
      width: 100%;
      height: auto;
      display: block;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.02);
      }
    }
  }

  .coupon-container {
    background-color: #fff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    margin-bottom: 24px;
    .coupon-header {
      text-align: center;
      padding-bottom: 24px;
      margin-bottom: 24px;
      border-bottom: 2px dashed #fe7448;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 16px;
        height: 16px;
        background-color: #f8f9fa;
        border-radius: 50%;
        box-shadow: 0 0 0 4px #fff;
      }

      .title-section {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;

        .icon-wrapper {
          background: linear-gradient(135deg, #fe7448, #ff9d6c);
          padding: 8px;
          border-radius: 12px;
          margin-right: 12px;
          box-shadow: 0 4px 8px rgba(254, 116, 72, 0.3);

          .coupon-icon {
            width: 36px;
            height: 30px;
            filter: brightness(0) invert(1);
          }
        }

        .title-text {
          font-size: 32px;
          font-weight: 700;
          color: #fe7448;
          margin: 0;
          text-shadow: 0 2px 4px rgba(254, 116, 72, 0.1);
        }
      }

      .subtitle {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translate(0, -50%);
        font-size: 16px;
        color: #fe7448;
        letter-spacing: 1px;
      }
    }

    .coupon-body {
      margin: 24px 0;
      min-height: calc(500px - 200px);
      .coupon-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 20px;

        .coupon-item {
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }

    .pagination-section {
      background-color: #fff;
      display: flex;
      justify-content: center;
      padding: 20px 0 0;

      .custom-pagination {
        ::v-deep .el-pagination__total,
        ::v-deep .el-pagination__jump {
          color: #666;
        }

        ::v-deep .el-pager li,
        ::v-deep .btn-prev,
        ::v-deep .btn-next {
          border-radius: 8px;
          margin: 0 4px;
          transition: all 0.3s;

          &:hover {
            color: #fe7448;
          }
        }

        ::v-deep .el-pager li.active {
          background-color: #fe7448;
          color: #fff;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .coupon-page {
    padding: 0 12px 16px;

    .coupon-container {
      padding: 16px;
      border-radius: 12px;

      .coupon-header {
        .title-section {
          .title-text {
            font-size: 24px;
          }

          .icon-wrapper {
            padding: 6px;

            .coupon-icon {
              width: 28px;
              height: 24px;
            }
          }
        }

        .subtitle {
          font-size: 14px;
        }
      }

      .coupon-body {
        .coupon-grid {
          grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
          gap: 16px;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .coupon-page {
    .coupon-container {
      .coupon-body {
        .coupon-grid {
          grid-template-columns: 1fr;
        }
      }
    }
  }
}
</style>
